import React, { useState, useEffect } from 'react'
import Headers from '../components/Headers'
import Footer from '../components/Footer'
import { Link, Outlet, useNavigate, useOutletContext, useSearchParams } from 'react-router-dom'
import { FaList } from 'react-icons/fa'
import { RxDashboard } from 'react-icons/rx'
import { RiProductHuntLine } from 'react-icons/ri'
import { BsHeart } from 'react-icons/bs'
import { FaUser } from 'react-icons/fa'
import api from '../api/api'
import { useDispatch, useSelector } from 'react-redux'

const Dashboard = ({sellerId, sellerName, isAdmin = false}) => {
    const outletContext = useOutletContext();
    const contextIsAdmin = outletContext?.isAdmin || false;
    const finalIsAdmin = isAdmin || contextIsAdmin;
    const [searchParams] = useSearchParams()
    const { userInfo } = useSelector(state => state.auth)
    const { guestCustomer } = useSelector(state => state.order)

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [filterShow, setFilterShow] = useState(false)
    const [isGuestMode, setIsGuestMode] = useState(false)

    useEffect(() => {
        // Check if we're in guest mode
        const email = searchParams.get('email') || localStorage.getItem('guestEmail')
        const phone = searchParams.get('phone') || localStorage.getItem('guestPhone')
        
        if (!userInfo && (email || phone)) {
            setIsGuestMode(true)
        } else {
            setIsGuestMode(false)
        }
    }, [userInfo, searchParams])

    useEffect(() => {
        if (finalIsAdmin) {
            document.title = "4POS eCommerce Admin Dashboard";
        } else {
            document.title = "4POS eCommerce Customer";
        }
    }, [finalIsAdmin]);

    return (
        <div className='min-h-screen flex flex-col'>
            <Headers sellerId={sellerId} sellerName={sellerName} />
            <div className='bg-slate-200 mt-5'>
                <div className='w-[90%] mx-auto pt-5 md-lg:block hidden'>
                    <div>
                        <button onClick={() => setFilterShow(!filterShow)} className='text-center py-3 px-3 bg-indigo-500 text-white'>
                            <FaList />
                        </button>
                    </div>
                </div>
                <div className='h-full mx-auto'>
                    <div className='py-5 flex md-lg:w-[90%] mx-auto relative'>
                        <div className={` rounded-md z-50 md-lg:absolute ${filterShow ? '-left-4' : '-left-[360px]'} w-[270px] ml-4 bg-white`}>
                            <ul className='py-2 text-slate-600 px-4'>
                                {isGuestMode ? (
                                    <>
                                        <li className='flex justify-start items-center gap-2 py-2'>
                                            <span className='text-xl'><FaUser /></span>
                                            <span className='block'>Guest User</span>
                                        </li>
                                        <li className='flex justify-start items-center gap-2 py-2'>
                                            <span className='text-xl'><RiProductHuntLine /></span>
                                            <Link to={`/${sellerName}/dashboard/my-orders`} className='block'>Track Orders</Link>
                                        </li>
                                        <li className='flex justify-start items-center gap-2 py-2'>
                                            <span className='text-xl'><BsHeart /></span>
                                            <Link to={`/${sellerName}/dashboard/my-wishlist`} className='block'>Wishlist</Link>
                                        </li>
                                        {guestCustomer && (
                                            <li className='mt-4 p-3 bg-blue-50 rounded-md'>
                                                <p className='text-sm text-blue-800'>
                                                    <strong>Welcome, {guestCustomer.name}!</strong><br/>
                                                    Email: {guestCustomer.email}<br/>
                                                    Phone: {guestCustomer.phone}
                                                </p>
                                            </li>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <li className='flex justify-start items-center gap-2 py-2'>
                                            <span className='text-xl'><RxDashboard /></span>
                                            <Link to={`/${sellerName}/dashboard`} className='block'>Dashboard</Link>
                                        </li>
                                        <li className='flex justify-start items-center gap-2 py-2'>
                                            <span className='text-xl'><RiProductHuntLine /></span>
                                            <Link to={`/${sellerName}/dashboard/my-orders`} className='block'>My Orders</Link>
                                        </li>
                                        <li className='flex justify-start items-center gap-2 py-2'>
                                            <span className='text-xl'><BsHeart /></span>
                                            <Link to={`/${sellerName}/dashboard/my-wishlist`} className='block'>Wishlist</Link>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>
                        <div className='w-[calc(100%-270px)] md-lg:w-full'>
                            <div className='mx-4 md-lg:mx-0'>
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer sellerId={sellerId} sellerName={sellerName}/>
        </div>
    )
}

export default Dashboard